RivalIQ.module('behaviors', function (behaviors, Admin, Backbone, Marionette, $, _) {

    'use strict';

    behaviors.DropdownSelector = Marionette.Behavior.extend({
        menuItemSelector: '.dropdown-selector a',

        ui: function () {
            const me = this;

            return {
                activeItem: '.dropdown-selector .dropdown-active',
                menuItems: me.getOption('menuItemSelector')
            };
        },

        events: {
            'click @ui.menuItems': 'onMenuItemSelect'
        },

        missingContentHtml: 'N/A',

        selectMissing: function () {
            const me = this;

            let missingContentHtml = me.getOption('missingContentHtml');
            if (_.isFunction(missingContentHtml)) {
                missingContentHtml = missingContentHtml.call(me);
            }

            me.ui.activeItem.html(missingContentHtml);
        },

        select: function (target, options) {
            const me = this;

            if (!target.length) {
                return me.selectMissing();
            }

            options = options || {};

            const data = target.data();

            me.ui.menuItems.parent().removeClass('active selected');
            target.parent().addClass('active selected');

            me.ui.activeItem.data(data);
            me.ui.activeItem.html(target.html());
            me.index = target.parent().index();

            // Initialize any popovers on active item
            me.ui.activeItem.find('[data-toggle="popover"]').popover();

            if (!options.silent) {
                // NOTE this could cause the dropdown to be destroyed, careful
                // about what you do from here on out!
                me.view.triggerMethod('select:dropdown', data);
            }

            me.view.triggerMethod('select:rendered');
        },

        onSelectNext: function () {
            const me = this;
            const index = (me.index + 1) % me.ui.menuItems.length;
            me.select($(me.ui.menuItems[index]));
        },

        onMenuItemSelect: function (e) {
            const me = this;
            const $el = $(e.currentTarget);

            me.$el.find('[data-toggle="popover"]').popover('hide');

            if ($el.parent().hasClass('disabled')) {
                e.stopPropagation();
                return;
            }

            me.select($el);
        },

        onShow: function () {
            const me = this;

            if (!me.view.isLoadingView || me.view.isDataLoaded()) {
                me.selectInitial();
            }
        },

        onRenderLoaded: function () {
            const me = this;
            me.selectInitial();
        },

        selectInitial: function () {
            const me = this;
            let item;

            const prop = me.options.prop;
            if (prop) {
                let propValue = me.view.getProp(prop);
                const propDefaultValue = me.options.propDefaultValue;
                if (_.isUndefined(propValue)) {
                    propValue = propDefaultValue;
                }
                item = me.ui.menuItems.filter(`[data-item-id="${propValue}"]`);
            } else if (me.view.defaultSelector) {
                let selector = me.view.defaultSelector;
                selector = (_.isFunction(selector) ? selector.call(me.view) : selector);

                item = me.ui.menuItems.filter(selector);
            } else {
                item = me.ui.menuItems.first();
            }

            me.select(item, {
                silent: !me.options.initialTrigger
            });
        },

        initialize: function (options) {
            const me = this;

            if (options.selectInitialOnRender) {
                me.listenToOnce(me.view, 'render', me.selectInitial);
            }
        }
    });
});
